import { render, staticRenderFns } from "./FinaliseDeletingView.vue?vue&type=template&id=3f5b6888&"
import script from "./FinaliseDeletingView.vue?vue&type=script&lang=js&"
export * from "./FinaliseDeletingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports